// extracted by mini-css-extract-plugin
export default {"Content":"ContentWrap_Content__T6s89"};